/**
 * Extracts placeholder ticket markers from markdown description
 * Placeholders are stored in a special markdown format during export
 */
export interface PlaceholderTicketFromMarkdown {
  title: string;
  originalText: string; // Store the original matched text for replacement
}

/**
 * Extract placeholder tickets from markdown
 * Format: #'Title Text Here'
 */
export function extractPlaceholderTicketsFromMarkdown(
  markdown: string,
): PlaceholderTicketFromMarkdown[] {
  const placeholders: PlaceholderTicketFromMarkdown[] = [];
  const regex = /#'((?:[^'\\]|\\.)*)'/g;

  let match;
  while ((match = regex.exec(markdown)) !== null) {
    const escapedTitle = match[1];
    // Unescape single quotes
    const title = escapedTitle.replace(/\\'/g, "'");
    placeholders.push({
      title,
      originalText: match[0], // Store full match like "#'Title'"
    });
  }

  return placeholders;
}

/**
 * Replace placeholder ticket markers with actual ticket references
 * Uses the original text to ensure exact match replacement
 * Adds the + suffix to show the ticket title inline
 */
export function replacePlaceholderInMarkdown(
  markdown: string,
  originalText: string,
  ticketIdOrNumber: number | string,
): string {
  // Escape special regex characters in the original text
  const escapedOriginal = originalText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(escapedOriginal, 'g');
  return markdown.replace(regex, `#${ticketIdOrNumber}+`);
}
